import usuarioUtil from '@/util/usuarioUtil'
import UploadFile from '@/components/layout/uploadFile/UploadFile.vue'
import imageStreamUtil from '@/components/layout/imageStream/js/util'
import { Cropper } from 'vue-advanced-cropper'
import 'vue-advanced-cropper/dist/style.css'
import { BToast } from 'bootstrap-vue'
import uploadImagem from './mixin/uploadImagem'
import CustomBackgroundWrapper from '../CustomBackgroundWrapper.vue'

export default {
  name: 'uploadLogotipo',
  props: {
    uploadFileRef: String,
    disabled: Boolean,
    codigoImagem: Object
  },
  components: {
    UploadFile,
    CustomBackgroundWrapper,
    Cropper,
    'b-toast': BToast
  },
  mixins: [uploadImagem],
  computed: {
    escritorioNaoTemLogo () {
      return (!usuarioUtil.usuarioTemFoto(this.codigoImagem))
    },
    exibirImagemSemLogo () {
      const usuarioTemFoto = usuarioUtil.usuarioTemFoto(this.codigoImagem)
      const temArquivoSelecionado = this.arquivoSelecionado !== null
      return (!usuarioTemFoto && !temArquivoSelecionado)
    },
    exibirLogo () {
      const usuarioTemFoto = usuarioUtil.usuarioTemFoto(this.codigoImagem)
      const temArquivoSelecionado = this.arquivoSelecionado !== null

      return (usuarioTemFoto || temArquivoSelecionado)
    },
    logoParaPrevisao () {
      const temArquivoSelecionado = this.arquivoSelecionado !== null
      const usuarioTemFoto = usuarioUtil.usuarioTemFoto(this.codigoImagem)
      if (temArquivoSelecionado) {
        return URL.createObjectURL(this.arquivoSelecionado)
      } else if (!temArquivoSelecionado && usuarioTemFoto) {
        return imageStreamUtil.obterEnderecoImagem(this.codigoImagem)
      }

      return require('@/assets/img/usuario-sem-foto.png')
    }
  },
  data: () => {
    return {
      cropperRef: 'logotipoCropper',
      backgroundColor: 'white'
    }
  },
  methods: {
    /*
     * O cropper mede o container no mount e não observa mudanças de tamanho. Quando ele nasce dentro de
     * um container escondido (aba inativa, modal fechado), as medidas são zero e a imagem não aparece —
     * quem exibe o componente nessa situação precisa chamar este refresh.
     */
    atualizarPreview () {
      const cropper = this.$refs[this.cropperRef]
      if (cropper) cropper.refresh()
    },

    aplicarAjustesNaImagem () {
      const { canvas } = this.$refs.logotipoCropper.getResult()
      const context = canvas.getContext('2d')
      context.globalCompositeOperation = 'destination-over'
      context.fillStyle = this.backgroundColor
      context.fillRect(0, 0, canvas.width, canvas.height)
      canvas.toBlob(result => {
        this.updateValue(result)
      }, 'image/png')
    }
  }
}
